module.exports = __webpack_public_path__ + "img/ico-rocket.ef08bf83.svg";